module.exports = __webpack_public_path__ + "static/media/back_05.8699d002.png";